import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { createStructuredSelector } from 'reselect';
import { customerSearch } from '../../modules/customer';
import { config, customer } from '../../modules';
import CustomerSearch from './components/CustomerSearch';

const Home = ({ searchButtonClickHandler, clearButtonClickHandler, searchCriteria, searchResults }) => 
    <div className="gemba">
        <div className="container-fluid">
            <CustomerSearch 
                searchCriteria={searchCriteria}
                searchResults={searchResults}
                clearButtonClickHandler={clearButtonClickHandler}
                searchButtonClickHandler={searchButtonClickHandler}
            />
        </div>
    </div>

Home.propTypes = {
};

const mapStateToProps = createStructuredSelector({
    searchCriteriaForm: customer.customerSearch.selectors.getSearchForm,
    searchResults: customer.customerSearch.selectors.getSearchResults
});

const mapDispatchToProps = {
    searchCriteriaChangeHandler: customer.customerSearch.actions.changeSearchCriteria,
    searchButtonClickHandler: () => customer.customerSearch.actions.customerLookup,
    clearButtonClickHandler: () => customer.customerSearch.actions.clearSearchCriteria,
    customerLookup: () => customer.customerSearch.actions.customerLookup
};

const mergeProps = (state, dispatch, own) => _.assign({}, state, dispatch, own, {
    searchCriteria: state.searchCriteriaForm(dispatch.searchCriteriaChangeHandler, dispatch.customerLookup)
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Home);